import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import cogoToast from 'cogo-toast';
import React, { useEffect, useRef, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { AiFillInfoCircle } from 'react-icons/ai';
import { FiUpload } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, CardHeader, Col, FormFeedback, Input, InputGroup, InputGroupText, Label, Row, Tooltip } from 'reactstrap';
import { GET_BENEFITS_GAMEFICATION, POST_IMAGE, POST_IMAGE_EMPTY } from '../../../../../../../../store/actions';

const statusOptions = [
  { value: 'draft', label: 'Draft' },
  { value: 'live', label: 'Live' },
];

const quizPriceOptions = [
  { value: 'free', label: 'Free' },
  { value: 'paid', label: 'Paid' },
];

const timeUnits = [
  { value: 'seconds', label: 'Second' },
  { value: 'minutes', label: 'Minute' },
];

const rewardOptions = [
  { value: 'points', label: 'Points' },
  { value: 'benefits', label: 'Benefits' },
];

const Form1 = ({ formData, errors, handleChange, handleNext, handleFlatpickrChange, setFormData }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [ttop, setttop] = useState(false);

  const [benefitOptions, setBenefitOptions] = useState([]);
  console.log('formdara', formData);
  console.log('benefit', benefitOptions);

  const { getBenefits, getBenefitsLoading } = useSelector((state: any) => ({
    getBenefits: state?.GetBenefitsGamification?.data,
    getBenefitsLoading: state?.GetBenefitsGamification?.loading,
  }));
  const { createUploadTicket } = useSelector((state: any) => ({
    createUploadTicket: state?.PostImage?.data,
    createUploadTicketLoading: state?.PostImage?.loading,
  }));

  useEffect(() => {
    if (getBenefits !== null) {
      if (formData?.reward_type === 'points') {
        handleChange('benefits', getBenefits?.inventory?.[0]?.id || '');
      } else if (formData?.benefits) {
        handleChange('benefits', '');
      }
      setBenefitOptions(
        getBenefits?.inventory?.map(benefit => {
          return { value: benefit?.id, label: benefit?.name, isDisabled: benefit.is_no_benefit };
        }),
      );
    }
  }, [getBenefits]);

  useEffect(() => {
    if (createUploadTicket !== null) {
      handleChange('banner', createUploadTicket?.data);
      dispatch({
        type: POST_IMAGE_EMPTY,
      });
    }
  }, [createUploadTicket]);

  const handleFileUpload = (files, type) => {
    const uploadedFile = files[0];
    if (!uploadedFile) return;

    const allowedExtensions = {
      image: ['jpg', 'jpeg', 'png', 'svg', 'webp'],
      video: ['mp4', 'avi', 'mov', 'mkv'],
    };

    const maxFileSize = {
      image: 10 * 1024 * 1024, // 10MB for images
      video: 50 * 1024 * 1024, // 50MB for videos
    };

    // Check if the provided type is valid
    if (!allowedExtensions[type]) {
      cogoToast.error(`Invalid file type: ${type}`);
      return;
    }

    const fileExtension = uploadedFile.name.split('.').pop().toLowerCase();

    // Validate the file extension based on the type
    if (!allowedExtensions[type].includes(fileExtension)) {
      cogoToast.error(`Invalid file extension for ${type}. Allowed: ${allowedExtensions[type].join(', ')}`);
      return;
    }

    // Validate the file size based on the type
    if (uploadedFile.size > maxFileSize[type]) {
      cogoToast.error(`File size exceeds the limit for ${type}. Max size: ${maxFileSize[type] / (1024 * 1024)}MB`);
      return;
    }
    const formData = new FormData();
    const newFile = new File([uploadedFile], uploadedFile.name, { type: uploadedFile.type });
    formData.append('file', newFile);
    dispatch({
      type: POST_IMAGE,
      payload: {
        data: formData,
        urlParam: {
          fileType: 4,
        },
      },
    });
  };

  const triggerUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <Card>
      <CardHeader className="mb-4 fw-medium fs-16">Quiz Configuration</CardHeader>
      <CardBody>
        <Row>
          <Col md={4}>
            <Label>Quiz Name</Label>
            <Input value={formData.game_name} onChange={e => handleChange('game_name', e.target.value)} invalid={!!errors.game_name} />
            <FormFeedback>{errors.game_name}</FormFeedback>
          </Col>

          <Col md={4}>
            <Tooltip
              placement="top"
              isOpen={ttop}
              target="TooltipTop"
              toggle={() => {
                setttop(!ttop);
              }}
            >
              Upload JPG, PNG. Resolution 500x500 max file size 10 MB
            </Tooltip>

            <Label>
              Upload Quiz Banner{' '}
              <span id="TooltipTop" className="cursor-pointer">
                <AiFillInfoCircle />
              </span>
            </Label>

            {/* Entire input clickable */}
            <div onClick={triggerUpload} style={{ cursor: 'pointer' }}>
              <InputGroup
                style={{
                  borderRadius: '5px',
                  overflow: 'hidden',
                  border: `1px solid ${errors?.banner ? '#dc3545' : '#d1d9e6'}`,
                  height: '40px',
                }}
              >
                <Input
                  placeholder={formData?.banner ? formData?.banner : 'Upload Banner'}
                  disabled
                  style={{
                    backgroundColor: '#f9fafb',
                    color: '#6b7280',
                    border: 'none',
                    pointerEvents: 'none', // prevent native focus behavior
                  }}
                  invalid={!!errors.banner}
                />
                <InputGroupText
                  style={{
                    backgroundColor: '#f9f9f9',
                    borderLeft: 'none',
                    pointerEvents: 'none', // icon should not steal the click
                    height: '40px',
                  }}
                >
                  <FiUpload size={18} />
                </InputGroupText>
              </InputGroup>
            </div>

            {/* Hidden file input */}
            <input type="file" accept="image/*" ref={fileInputRef} onChange={e => handleFileUpload(e.target.files, 'image')} hidden />

            {!!errors.banner && <FormFeedback style={{ display: 'block' }}>{errors.banner}</FormFeedback>}
          </Col>

          <Col md={4}>
            <Label>Status</Label>
            <Select
              options={statusOptions}
              value={statusOptions.find(opt => opt.value === formData.status)}
              onChange={opt => handleChange('status', opt.value)}
              className={errors.status && 'is-invalid'}
            />
            {errors.status && <div className="text-danger mt-1">{errors.status}</div>}
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={4}>
            <Label>Start Date</Label>
            <Flatpickr
              className={`form-control ${errors.start_date ? 'is-invalid' : ''}`}
              value={formData.start_date}
              onChange={date => handleFlatpickrChange('start_date', date)}
              options={{ dateFormat: 'Y-m-d' }}
            />
            <FormFeedback>{errors.start_date}</FormFeedback>
          </Col>
          <Col md={4}>
            <Label>End Date</Label>
            <Flatpickr
              className={`form-control ${errors.end_date ? 'is-invalid' : ''}`}
              value={formData.end_date}
              onChange={date => handleFlatpickrChange('end_date', date)}
              options={{ dateFormat: 'Y-m-d' }}
            />
            <FormFeedback>{errors.end_date}</FormFeedback>
          </Col>
          <Col md={4}>
            <Label>Min Points to Play</Label>
            <Input
              type="number"
              value={formData.min_coins_required}
              onChange={e => handleChange('min_coins_required', e.target.value)}
              invalid={!!errors.min_coins_required}
              onKeyDown={e => {
                if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
              }}
              onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                e.currentTarget.blur();
              }}
            />
            <FormFeedback>{errors.min_coins_required}</FormFeedback>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={4}>
            <Label>Set Time Limit</Label>
            <Row>
              <Col>
                <Input
                  type="number"
                  value={formData.play_duration}
                  onChange={e => handleChange('play_duration', e.target.value)}
                  invalid={!!errors.play_duration}
                  onKeyDown={e => {
                    if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
                  }}
                  onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                    e.currentTarget.blur();
                  }}
                />
                {errors.play_duration && <FormFeedback>{errors.play_duration}</FormFeedback>}
              </Col>
              <Col>
                <Select
                  options={timeUnits}
                  value={timeUnits.find(opt => opt.value === formData.play_duration_unit)}
                  onChange={opt => handleChange('play_duration_unit', opt.value)}
                  className={errors.play_duration_unit && 'is-invalid'}
                />
                {errors.play_duration_unit && <div className="text-danger mt-1">{errors.play_duration_unit}</div>}
              </Col>
            </Row>
          </Col>

          <Col md={3}>
            <label className="form-label">Select Reward Type</label>
            <Select
              options={rewardOptions}
              value={rewardOptions.find(opt => opt.value === formData.reward_type)}
              onChange={option => {
                handleChange('reward_type', option.value);
                // Reset conditional fields
                dispatch({
                  type: GET_BENEFITS_GAMEFICATION,
                  payload: {
                    urlParams: {
                      type: option?.value,
                    },
                  },
                });
                if (option.value === 'benefits') {
                  handleChange('benefits', '');
                } else {
                  handleChange('points', '');
                }
              }}
            />
            {errors.reward_type && <div className="text-danger mt-1">{errors.reward_type}</div>}
          </Col>

          {formData.reward_type === 'points' && (
            <Col md={2}>
              <label className="form-label">Add Points</label>
              <Input
                type="number"
                value={formData.points}
                onChange={e => handleChange('points', e.target.value)}
                onKeyDown={e => {
                  if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
                }}
                onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                  e.currentTarget.blur();
                }}
              />
              {errors?.points && <div className="text-danger mt-1">{errors?.points}</div>}
            </Col>
          )}

          {formData.reward_type === 'benefits' && (
            <Col md={2}>
              <label className="form-label">Quiz Price</label>
              <Select
                options={benefitOptions}
                value={benefitOptions.find(opt => opt.value === formData.benefits)}
                onChange={option => handleChange('benefits', option.value)}
              />
              {errors?.benefits && <div className="text-danger mt-1">{errors?.benefits}</div>}
            </Col>
          )}

          <Col md={3}>
            <label className="form-label">Max Unit Allowed</label>
            <Input
              type="number"
              value={formData.max_unit_allowed}
              onChange={e => handleChange('max_unit_allowed', e.target.value)}
              onKeyDown={e => {
                if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
              }}
              onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
                e.currentTarget.blur();
              }}
            />
            {errors?.max_unit_allowed && <div className="text-danger mt-1">{errors?.max_unit_allowed}</div>}
          </Col>

          <Col md={2} className="mt-3">
            <Label>Is Featured</Label>
            <div className="form-check form-switch">
              <Input
                type="checkbox"
                name="is_featured"
                className="form-check-input"
                checked={formData.is_featured}
                onChange={e => setFormData({ ...formData, is_featured: !formData?.is_featured })}
                style={{ width: '50px', height: '23px' }}
              />
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Label>Quiz Information</Label>
            <CKEditor
              editor={ClassicEditor}
              data={formData.description}
              onChange={(event, editor) => {
                const data = editor?.getData();
                handleChange('description', data);
              }}
            />
            <FormFeedback>{errors.description}</FormFeedback>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <Button color="success" style={{ fontSize: '17px', padding: '6px 57px', borderRadius: '8px' }} onClick={handleNext}>
            Next
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default Form1;
